<template>

  <t-page>

    <t-page-form card :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">


      <t-input v-model="form.sellerId" hidden/>

      <t-input label="Vendedor vinculado a usuário da plataforma?" v-model="yesOrNotLinkUser" :options="yesOrNotOptions"
               radio/>

      <div v-show="onYesLinkUser">

        <t-input v-model="form.userId" :options="usersOptions" :add-error="error.userId"
                 label="Usuário da plataforma" :required="onYesLinkUser" select/>

      </div>


      <div v-show="!onYesLinkUser">

        <t-input v-model="form.name"  :add-error="error.name" label="Nome" :required="!onYesLinkUser"/>

      </div>


      <t-input v-model="form.note" label="Observações" max-length="500" textarea/>

      <t-input-status v-model="form.status"/>

    </t-page-form>

  </t-page>

</template>
<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import userService from "@/services/modules/setting/User.service";

export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  name: 'SellerForm',

  data() {
    return {
      path: "", //Utilizar somente quando fora do padrão
      form: {
        sellerId: 0,
        userId: 0,
        name: "",
        note: "",
        status: 1 //2 = Inativo else ativo 0,1 ou nulo será ativo,
      },
      error: {//Campos que podem receber retorno de erro do backend
        userId: "",
        name: "",
      },
      yesOrNotLinkUser: "N", //Valor padrão não possui vinculo com usuário
      usersOptions: [],

    }
  },
  methods: {

    async onSubmit() {

      //Envio padrão com crud, tratativa de erro padrão e especificação somente após a ação padrão ser realizada. Caso não desejar o envio padrão utilizar somente "this.setSending()"
      await this.setSendingDefault("sellerId")


    },

    mountedPrepare(){


    },
    async mountedContinued(){

      await userService.selectList("").then((list) =>{
        this.usersOptions = list
      }).catch(error => this.responseError(error))

      this.pageFormIsLoaded = true

      if (this.form.userId > 0) {
        this.yesOrNotLinkUser = "Y"
      }

    }

  },
  async mounted() {

    this.mountedPrepare()

    //Padrão inicialização ------------------------------
    await this.mountedForm(true, false)
    //---------------------------------------------------

    await this.mountedContinued()


  },
  computed: {
    onYesLinkUser() {
      return this.yesOrNotLinkUser === 'Y'
    }
  }

}
</script>
